export const chapterMenu = [
  {
    id: "01",
    text: "01. Preface\n“To boldly go where\nno man has gone before...”",
    x: 0,
    space: 24,
  },
  {
    id: "02",
    text: "02. Astronauts\nin Training",
    x: 26,
    space: 18,
  },
  {
    id: "03",
    text: "03. Indoor tests\nat the manned\nspacecraft center",
    x: 45,
    space: 15,
  },
  {
    id: "04",
    text: "04. Saturn V\nand Lunar\nLanding Module",
    x: 65,
    space: 13,
  },
  {
    id: "05",
    text: "05. Houston:\nWe Have Lift-off",
    x: 83,
    space: 21,
  },
  {
    id: "06",
    text: "06. Journey\nThrough Space",
    x: 100,
    space: 22,
  },
  {
    id: "07",
    text: "07. The Moon’s\nSurface",
    x: 117,
    space: 20,
  },
  {
    id: "08",
    text: "08. One Giant\nLeap for Mankind",
    x: 133,
    space: 16,
  },
  {
    id: "09",
    text: "09. Research\nand Experiments",
    x: 150,
    space: 26,
  },
  {
    id: "10",
    text: "10. Rendezvous\nin Space",
    x: 167,
    space: 18,
  },
];
